// REACT IMPORTS
import React, { useState, useEffect } from "react";

// CONTROLS IMPORTS
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import { Box, TextField, Menu, MenuItem, Divider, IconButton, Grid,
    FormControl, InputLabel, Select, Typography, Button, Checkbox
 } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

// ICONS IMPORTS
import MenuIcon from '@mui/icons-material/Menu';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';

// REDUX IMPORTS
import { useDispatch, useSelector } from 'react-redux';
import { load, remove } from '../../store/thunks';
import { selectItem, showUserModal } from '../../store/slices';
import BodyMain from "../../components/util/BodyMain";

// LANGUAGE IMPORTS
import { useTranslation } from 'react-i18next';

// OWNED COMPONENTS IMPORTS
import { constants } from  '../../util'
import SaveUser from "./saveUser";
import Confirmation from "../../components/message/confirmation";



const Users = () => {
    // TRANSLATIONS
    const [t, i18n] = useTranslation("global");


    // LOCAL VARIABLES
    const columsGrid = 
    [
        {
            field: 'userId',
            description: '',
            headerName: '',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClickMenu(e, params.value)}
                                aria-label="menu"
                            >
                                <MenuIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'name',
            description: t("userAdmin.name"),
            headerName: t("userAdmin.name"),
            type: 'string',
            width: 200,
            headerAlign: 'left',
        },
        {
            field: 'email',
            description: t("userAdmin.email"),
            headerName: t("userAdmin.email"),
            type: 'string',
            width: 300,
            headerAlign: 'left',
        },
        {
            field: 'roleName',
            description: t("userAdmin.role"),
            headerName: t("userAdmin.role"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        {
                            params.value==='Administrador'
                                ? ( language === 'es' ? 'Administrador' : 'Administrator' )
                                : params.value==='Aprobador'
                                    ? ( language === 'es' ? 'Aprobador' : 'Reviewer' )
                                    : params.value==='Artista'
                                        ? ( language === 'es' ? 'Artista' : 'Artist' )
                                        : ''
                        }
                    </div>
                );
            }
        },
        {
            field: 'active',
            description: t("userAdmin.active"),
            headerName: t("userAdmin.active"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        {
                            params.value==='Activo' || params.value==='Active'
                                ? ( language === 'es' ? 'Activo' : 'Active' )
                                : ( language === 'es' ? 'Inactivo' : 'Inactive' )
                        }
                    </div>
                );
            }
        },
    ];


    const sch = (yup) => yup.object({
        name: yup.string().max(40),
        email: yup.string().max(40),
        roleId: yup.number(),
        active: yup.string()
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                name: '',
                email: '',
                roleId: -1,
                active: '-1'
            }
        });

    
    // LOCAL STATES
    const [titleAddUsersModal, setTitleAddUsersModal] = useState('');
    const [actionAddUsersModal, setActionAddUsersModal] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    
    // NEEDED HOOKS
    const dispatch = useDispatch();
    const { items: userList, selectedId, selectedItem } = useSelector(state => state.userAdmin);
    const { language } = useSelector(state => state.configuration);

    // EFFECTS
    useEffect(() => {
        dispatch(
            load
            (
                {
                    userId: '-1',
                    name: '',
                    email: '',
                    active: 'true',
                    roleId: '-1'
                }
            )
        )
    }, [])

    // LOCAL FUNCTIONS
    const onSubmit = (data) => {
        dispatch(
            load
            (
                {
                    userId: '-1',
                    name: data.name,
                    email: data.email,
                    active: data.active,
                    roleId: data.roleId.toString()
                }
            )
        )
    }

    const handleClickDelete = () => {
        console.log(selectedItem);
        console.log(selectedId);
        
        
        dispatch(remove(selectedId.toString()));
    }

    const handleClickMenu = (event, id) => {
        setAnchorEl(event.currentTarget);
        dispatch(selectItem(id));
    };

    const handleClickMenu_Go = (action) => {
        switch(action)
        {
            case 'add':
                setTitleAddUsersModal(
                    language==='es'
                        ? 'Agregar usuario'
                        : 'Add user'
                );
                dispatch(selectItem(null));
                setActionAddUsersModal(action);
                dispatch(showUserModal(true));
                break;
            case 'edit':
                setTitleAddUsersModal(
                    language==='es'
                        ? 'Editar usuario'
                        : 'Edit user'
                );
                setActionAddUsersModal(action);
                dispatch(showUserModal(true));
                break;
            case 'view':
                setActionAddUsersModal(action);
                setTitleAddUsersModal(
                    language==='es'
                        ? 'Ver detalle de usuario'
                        : 'View user detail'
                );
                dispatch(showUserModal(true));
                break;
            case 'delete':
                setShowConfirmation(true);
                break;
            default:
                setTitleAddUsersModal('');
                break;
        }
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    
    return(
        <>
            <BodyMain>
                <h2 style={{color:'#667'}}>{t("userAdmin.title")}</h2>
                <form onSubmit={handleSubmit(onSubmit)}
                    style={{
                        width:'100%',
                        height:'100%',
                        display:'flex',
                        flexDirection:'column',
                        marginBottom:'50px'
                    }}
                >
                    <Grid container size={12} spacing={2}>
                        <Grid size={6}>
                            <TextField id="txtName" label={t("userAdmin.name")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('name')}
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Controller
                                name="roleId"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.roleId}>
                                    <InputLabel id="status-label">{t("userAdmin.role")}</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="status-label"
                                        label={t("userAdmin.role")}
                                        sx={{ width: '100%', marginBottom: '0px' }}
                                    >
                                        <MenuItem value={-1}>
                                            <Typography>{ language==='es' ? 'Todos los perfiles' : 'All roles'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={3}>
                                            <Typography>{ language==='es' ? 'Artista' : 'Artist'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={2}>
                                            <Typography>{ language==='es' ? 'Aprobador' : 'Reviewer'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={1}>
                                            <Typography>{ language==='es' ? 'Administrador' : 'Administrator'}</Typography>
                                        </MenuItem>
                                    </Select>
                                    {/* <FormHelperText>
                                        {errors.statusId?.message}
                                    </FormHelperText> */}
                                </FormControl>
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container size={12} spacing={2}>
                        <Grid size={6}>
                            <TextField id="txtEmail" label={t("userAdmin.email")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('email')}
                                error={!!errors.email}
                                helperText={errors.email?.message}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Controller
                                name="active"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.active}>
                                    <InputLabel id="active-label">{t("userAdmin.active")}</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="active-label"
                                        label={t("userAdmin.active")}
                                        sx={{ width: '100%', marginBottom: '0px' }}
                                    >
                                        <MenuItem value={'-1'}>
                                            <Typography>{ language==='es' ? 'Todos los estados' : 'All status'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={'true'}>
                                            <Typography>{ language==='es' ? 'Activo' : 'Active'}</Typography>
                                        </MenuItem>
                                        <MenuItem value={'false'}>
                                            <Typography>{ language==='es' ? 'Inactivo' : 'Inactive'}</Typography>
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container size={12} spacing={2}>
                        <Button
                            type="submit"
                            variant="outlined"
                            sx={{ ...constants.styles.mainButton, width: 'auto-fit', paddingLeft:'80px', paddingRight:'80px' }}
                        >
                            {t("userAdmin.search")}
                        </Button>
                    </Grid>
                </form>
                <Box sx={{ 
                    width: '100%',
                    '& .alternateClass': {
                        backgroundColor: '#f2f2f2',
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .rowClass': {
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .alternateClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                    '& .rowClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                }}>
                    <Button 
                        component="label" 
                        variant="text" 
                        startIcon={<AddIcon />}
                        sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative', }}
                        onClick={()=>handleClickMenu_Go('add')}
                    >
                        {t("userAdmin.btnAdd")}
                    </Button>
                    <DataGrid
                        getRowId={(row) => row.userId}
                        getRowHeight={() => 40}
                        rows={userList || []}
                        columns={columsGrid}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            density: 'compact',
                        }}
                        // paginationModel={{ page: 0, pageSize: 100 }} // Muestra todas las filas
                        // pageSizeOptions={[]} // Oculta el selector de páginas
                        // hideFooter
                        getRowClassName ={
                            (params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                        }
                        pageSizeOptions={[5,10,20,{value:-1, label:language==='es' ? 'Todo' : 'All'}]}
                        checkboxSelection = {false}
                        disableRowSelectionOnClick
                        disableColumnMenu
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            }
                        }}
                        localeText={
                            language === 'es' 
                            ? esES.components.MuiDataGrid.defaultProps.localeText
                            : enUS.components.MuiDataGrid.defaultProps.localeText
                        }
                        sx={{
                            '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                color: '#667', 
                                fontSize: '0.8rem',
                            },
                        }}
                    />
                </Box>
                <br /><br />
            </BodyMain>

            <Menu 
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 120,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => handleClickMenu_Go('view')}>
                    <VisibilityIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu1")}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleClickMenu_Go('edit')}>
                    <EditIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu2")}
                </MenuItem>
                <MenuItem onClick={() => handleClickMenu_Go('delete')}>
                    <DeleteForeverRoundedIcon sx={{marginRight:'15px'}} />
                    {t("songs.gridMenu3")}
                </MenuItem>
            </Menu>
            <SaveUser title={titleAddUsersModal} action={actionAddUsersModal} />
            <Confirmation 
                title={language==='es' ? 'Confirmación' : 'Confirmation'}
                content={language==='es' ? '¿Está seguro que desea eliminar al usuario seleccionado?' : 'Are you sure you wish to remove the selected user?'} 
                open={showConfirmation} onClose={()=>setShowConfirmation(false)} 
                onResponse={handleClickDelete} />
        </>
    )
}

export default Users;